import { forwardRef } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import style from './ManagePromo.style'
import Button from '../Button'

const ManagePromoStyled = styled.div(props => ({ ...style(props) }))

const ManagePromo = forwardRef(
    ({ image, title, titleTag: TitleTag, subtitle, text, buttonText, buttonLink, offsetFunc }, ref) => {
        return (
            <ManagePromoStyled image={image} ref={ref}>
                <div className="ManagePromoContainer">
                    <div className="Content">
                        <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title }} />
                        {subtitle ? <p className="Subtitle">{subtitle}</p> : ''}
                        {text ? <p className="Text">{text}</p> : ''}
                        <div className="ButtonDesktop">
                            {buttonLink ? (
                                <Button
                                    white
                                    variation="primary rounded"
                                    link={buttonLink}
                                    dataAttrs={{
                                        'gtm-event': 'link',
                                        'gtm-label': title,
                                        'gtm-action': buttonText,
                                        'gtm-category': 'ManagePromo'
                                    }}>
                                    {buttonText}
                                </Button>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div className="Image" />
                    <div className="ButtonMobile">
                        {buttonLink ? (
                            <Button
                                small
                                white
                                variation="primary rounded"
                                link={buttonLink}
                                dataAttrs={{
                                    'gtm-event': 'link',
                                    'gtm-label': title,
                                    'gtm-action': buttonText,
                                    'gtm-category': 'ManagePromo'
                                }}>
                                {buttonText}
                            </Button>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </ManagePromoStyled>
        )
    }
)

ManagePromo.propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    titleTag: PropTypes.string,
    text: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
    offsetFunc: PropTypes.string.isRequired
}

ManagePromo.defaultProps = {
    titleTag: 'p',
    text: null,
    subtitle: null,
    buttonText: null,
    buttonLink: null
}

export default withTheme(ManagePromo)
